import { CommApiInstance } from "Utils/CommApiInstance";


const MembGameSvcItemOdrLstInqApi = async (
    gameSvcCd:string,
    nowPageNo:number,
    srchStrtDt:string,
    srchEndDt:string
) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/item_odr_lst?page=${nowPageNo}`,{
        apiBody: {
            srchStrtDt: srchStrtDt,
            srchEndDt: srchEndDt
        }
    })
    .then((Resp) => Resp.data);
}

export default MembGameSvcItemOdrLstInqApi;